import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Typography from '@mui/material/Typography';

function Contact(){
    return(
        <>
            <div className="Contact-maincontent">
                <Typography variant="h1">Contact Me</Typography>
                <Typography variant="body1"> I haven't made a contact form yet,
                so for now just email me at linhnguyen.tibiaart@gmail.com
                if you would like to correspond with me.</Typography>
            </div>
        </>
    );
}

export default Contact;